import { addFeatureFlagEvaluation } from './datadogRumUtils';
import { useEffect } from 'react';

/**
 * Custom hook to add provided feature flag value pairs to an
 * existing RUM session.
 *
 * @param featureFlags Key value pair of flag name and flag value
 */
export function useFeatureFlagEvaluation(
  featureFlags: Record<string, string | number | boolean> | undefined,
): void {
  useEffect(() => {
    addFeatureFlagEvaluation(featureFlags);
  }, [featureFlags]);
}
